
/**
 * @name APP cmmApp
 * @autor daniel.molina@u-planner.com
 * @description vista tabla para forecast
 * # name controller --> powerbiPerfilCtrl
 * # alias: --> powerbiCtrl
 */
 export default class powerbiPerfilCtrl{
	constructor($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant,LOCAL_ENV_CONSTANT) {
           
           	$scope.title='Reporte perfil de profesores'

           	$scope.POWER=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY2;

           	$scope.workspaceId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
           	$scope.reportId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY2;
   }

}

powerbiPerfilCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','LOCAL_ENV_CONSTANT'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfilPowerbi/powerbiPerfilCtrl.js